import Vue from 'vue'
import App from './resourcelabmap.vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIpjmNdGh8vZZDD4-ZFmvcxRM8vuE0vgU',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  }
});

new Vue({
  render: h => h(App),
}).$mount('#resourcelabmap');
